import React from "react";

const InputTextarea = ({
  onChange,
  onBlur,
  value,
  error,
  errorMsg,
  placeholder,
  label,
  className,
  maxLength,
  name,
  rows = 2,
  textareaClassName,
  labelClassName,
  isRequired = false,
  isSpace = true,
}) => {
  const handleChange = (e) => {
    let inputValue = e.target.value;

    if (isSpace) {
      inputValue = inputValue.replace(/^\s+/, "");
    }
    if (maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }
    if (onChange) {
      onChange({
        target: {
          name,
          value: inputValue,
        },
      });
    }
  };

  return (
    <div className={`${className} w-full`}>
      <label
        htmlFor={name}
        className={`font-semibold text-[14px] text-foreground ${labelClassName}`}
      >
        {label}
        {isRequired && <span className="text-[#FF5C5C]">*</span>}
      </label>
      {label && <br />}
      <textarea
        name={name}
        // onChange={(e) => {
        //   if (onChange) {
        //     onChange(e);
        //   }
        // }}
        onChange={handleChange}
        onBlur={(e) => {
          if (onBlur) {
            onBlur(e);
          }
        }}
        value={value}
        rows={rows}
        maxLength={maxLength}
        placeholder={placeholder}
        className={`
          w-full
          bg-background
          border
          border-input
          rounded-md
          shadow-sm
          shadow-black/5
          px-4
          py-3
          text-sm
          text-foreground
          placeholder:text-muted-foreground/80
          focus-visible:outline-none
          focus-visible:ring-[3px]
          focus-visible:ring-ring/30
          focus-visible:border-ring
          disabled:cursor-not-allowed
          disabled:opacity-60
          ${error ? "border-red-500" : "border-zinc-200"}
          ${textareaClassName}
        `}
      />
      {error ? (
        <div className="text-[0.8125rem] text-red-500">{errorMsg}</div>
      ) : null}
    </div>
  );
};

export default InputTextarea;
